document.addEventListener("DOMContentLoaded", () => {
    // --- Configuration ---
    const animationDuration = 0.7;
    const swipeThreshold = 50;

    // --- DOM Elements ---
    const wrapper = document.querySelector(".ysl-slideshow-wrapper");
    const track = document.querySelector(".ysl-slideshow-track");
    const slides = document.querySelectorAll(".fullscreen-slide");

    if (!wrapper || !track || slides.length === 0) {
        console.warn("Slideshow elements not found.");
        return;
    }

    // --- State Variables ---
    let currentIndex = 0;
    const totalSlides = slides.length;
    let isAnimating = false;
    let touchStartY = 0;
    let touchEndY = 0;
    let currentWrapperHeight = 0; // Store wrapper height in pixels

    // --- Function to Set Slide Heights based on Wrapper ---
    function setSlideHeights() {
        // *** CHANGE: Measure wrapper's offsetHeight ***
        currentWrapperHeight = wrapper.offsetHeight;

        // Basic check in case offsetHeight isn't available immediately
        if (currentWrapperHeight === 0) {
            console.warn("Wrapper height is 0. Retrying slightly later.");
            // Retry once after a short delay - consider a more robust solution if this occurs frequently
            setTimeout(setSlideHeights, 100);
            return; // Exit this attempt
        }

        slides.forEach(slide => {
            // Apply measured wrapper height to each slide
            slide.style.height = `${currentWrapperHeight}px`;
        });

        // Update track position immediately based on new height, only if not animating
        if (!isAnimating) {
             // *** CHANGE: Use wrapper height for positioning ***
             gsap.set(track, { y: -currentWrapperHeight * currentIndex });
        }
        // console.log(`Slide heights set to wrapper height: ${currentWrapperHeight}px`); // Optional debug
    }

    // --- Core Function: Show Specific Slide ---
    function showSlide(index) {
        // *** CHANGE: Use the stored wrapper height for animation calculation ***
        const animationHeight = currentWrapperHeight;

        // If height hasn't been calculated yet, try one more time
        if (animationHeight === 0) {
             console.warn("Wrapper height still 0 when trying to animate. Recalculating.");
             setSlideHeights(); // Try setting heights again
             // Use the newly calculated height (if successful) or fallback (e.g., window.innerHeight)
             const fallbackHeight = wrapper.offsetHeight || window.innerHeight;
             if (fallbackHeight === 0) {
                 console.error("Cannot animate, height is 0.");
                 return; // Prevent animation if height is invalid
             }
             currentIndex = Math.max(0, Math.min(index, totalSlides - 1));
             isAnimating = true;
             gsap.to(track, { duration: animationDuration, y: -fallbackHeight * currentIndex, ease: "power2.inOut", onComplete: () => { /*...*/ } });
             return; // Exit after using fallback
        }


        currentIndex = Math.max(0, Math.min(index, totalSlides - 1));
        isAnimating = true;

        // console.log(`Animating to index ${currentIndex}, targetY: ${-animationHeight * currentIndex}`); // Optional debug

        gsap.to(track, {
            duration: animationDuration,
            y: -animationHeight * currentIndex, // Use measured wrapper height
            ease: "power2.inOut",
            onComplete: () => {
                setTimeout(() => {
                    isAnimating = false;
                    // console.log("Animation complete."); // Optional debug
                }, 100);
            }
        });
    }

    // --- Navigation Functions ---
    function goToNextSlide() { if (!isAnimating && currentIndex < totalSlides - 1) showSlide(currentIndex + 1); }
    function goToPrevSlide() { if (!isAnimating && currentIndex > 0) showSlide(currentIndex - 1); }


    // --- Event Listener: Mouse Wheel ---
    wrapper.addEventListener("wheel", (e) => {
        if (e.target.closest('.scrollable-content')) return;
        e.preventDefault();
        if (isAnimating) return;
        if (e.deltaY > 0) { goToNextSlide(); } else if (e.deltaY < 0) { goToPrevSlide(); }
    }, { passive: false });

    // --- Touch Event Listeners ---
    wrapper.addEventListener("touchstart", (e) => { if (!isAnimating) { touchStartY = e.touches[0].clientY; touchEndY = touchStartY; } }, { passive: false });
    wrapper.addEventListener("touchmove", (e) => { e.preventDefault(); if (!isAnimating) { touchEndY = e.touches[0].clientY; } }, { passive: false });
    wrapper.addEventListener("touchend", () => {
        if (isAnimating) return;
        const deltaY = touchStartY - touchEndY;
        if (Math.abs(deltaY) > swipeThreshold) { if (deltaY > 0) { goToNextSlide(); } else { goToPrevSlide(); } }
        touchStartY = 0; touchEndY = 0;
    }, { passive: true });

    // --- Debounced Resize Handler ---
    let resizeTimeout;
    function debounce(func, delay) {
        return function(...args) { clearTimeout(resizeTimeout); resizeTimeout = setTimeout(() => func.apply(this, args), delay); };
    }
    const handleResize = debounce(() => { /*console.log("Window resized, updating heights...");*/ setSlideHeights(); }, 250);
    window.addEventListener("resize", handleResize);

    // --- Initial Setup ---
    // Use requestAnimationFrame to wait for initial layout might be slightly better
    requestAnimationFrame(() => {
        setTimeout(() => { // Add extra small delay just in case layout takes time
             setSlideHeights();
             console.log("Slideshow initialized.");
        }, 50);
    });


}); // End DOMContentLoaded